import { useEffect, useState } from 'react';
import {
  GridActionsCellItem,
  DataGridPro as DataGrid,
} from '@mui/x-data-grid-pro';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box } from '@mui/material';
import * as service from '../../../services/deere-service';
import ConfirmationDialog from '../../../components/ConfirmationDialog/ConfirmationDialog';

export function Subscriptions() {
  const [subscriptions, setSubscriptions] = useState();
  const [subscriptionToDelete, setSubscriptionToDelete] = useState();

  useEffect(() => {
    service.getSubscriptions().then(setSubscriptions);
  }, []);

  return (
    <Box
      sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      {subscriptionToDelete && confirmDelete()}
      <DataGrid
        sx={{ flex: 1 }}
        loading={!subscriptions}
        columns={buildColumns()}
        rows={subscriptions || []}
      />
    </Box>
  );

  function buildColumns() {
    return [
      {
        field: 'event',
        headerName: 'Event',
        flex: 1,
      },
      {
        field: 'filters',
        headerName: 'Filters',
        flex: 2,
        valueFormatter: ({ value }) => JSON.stringify(value),
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: '',
        getActions: ({ row }) => [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => setSubscriptionToDelete(row.id)}
          />,
        ],
      },
    ];
  }

  function confirmDelete() {
    return (
      <ConfirmationDialog
        title="Delete Subscription"
        message={`Are you sure you want to delete this subscription`}
        handleClose={() => setSubscriptionToDelete(null)}
        handleConfirm={() => deleteSubscription(subscriptionToDelete)}
      />
    );
  }

  async function deleteSubscription(id) {
    setSubscriptionToDelete(null);

    await service.deleteSubscription(id).then(() => {
      setSubscriptions((current) => current.filter((c) => c.id !== id));
    });
  }
}
